import React, { useState, useEffect } from 'react';
import './teachers.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const { readCookie } = require('../../Functions/Cookies.js');

function TeacherInfo() {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [role, setRole] = useState('');
  const [signUpDate, setSignUpDate] = useState('');
  const [prev, setPrev] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const showToastMessageSuccess = (msg) => toast.success(msg);
  const ShowToastMessageError = (msg) => toast.error(msg);

  const handleEdit = () => {
    setPrev({ name, email, contact, role, expiryDate });
    setPassword('');
    setIsEditing(true);
  };

  const saveDetails = async () => {
    if (!isEditing) return;

    let obj = {};
    if (name !== prev.name) obj.name = name;
    if (email !== prev.email) obj.email = email;
    if (contact !== prev.contact) obj.contact = contact;
    if (role !== prev.role) obj.role = role;
    if (expiryDate !== prev.expiryDate) obj.expiryDate = expiryDate;
    if (password) obj.password = password;

    const staffId = localStorage.getItem('staffId');

    try {
      const res = await fetch(`${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          token: readCookie('token'),
        },
        body: JSON.stringify({...obj,password}),
      });
      const data = await res.json();
      if (data.status !== 'success') throw new Error(data.message);

      // refetch updated teacher info
      await fetchTeacher();
      setIsEditing(false);
      setPassword('#123456789'); // clear password field
      showToastMessageSuccess('Details Updated!!');
    } catch (err) {
      ShowToastMessageError(err.message || err);
    }
  };

  const fetchTeacher = async () => {
    const staffId = localStorage.getItem('staffId');
    const res = await fetch(`${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}`, {
      headers: { token: readCookie('token') },
    });
    const data = await res.json();
    const t = data.data.staff;
    setName(t.name);
    setEmail(t.email);
    setContact(t.contact);
    setRole(t.role);
    setExpiryDate(t.expiryDate.split('T')[0]);
    setSignUpDate(t.signUpDate.split('T')[0]);
    setPassword('#123456789'); // hide password initially
  };

  useEffect(() => {
    fetchTeacher();
  }, []);

  return (
    <div
      id='teacherInfo'
      className='teacher_right_side_bottom_right_info VerticalTabs'
    >
      <ToastContainer />
      <div className='rightSchoolDetails'>
        <div className='rightSchoolDetails-upper'>
          <div className='rightSchoolDetails-upper-left'>
            <label>Name</label>
            <input
              className='name'
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={!isEditing}
            />
          </div>
          <div
            className='rightSchoolDetails-upper-righst'
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '48%',
              marginTop: '0px',
              marginBottom: '2px',
            }}
          >
            <label style={{ marginBottom: '2px' }}>SignUp Date</label>
            <input
              type='date'
              value={signUpDate}
              style={{
                width: '100%',
                border: '1px solid gray',
                marginTop: '1px',
                height: '30px',
              }}
              disabled
            />
          </div>
        </div>

        <div
          className='rightSchoolDetails-lower'
          style={{ marginBottom: '30px' }}
        >
          <div className='rightSchoolDetails-lower-left'>
            <label>Email</label>
            <input
              className='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={!isEditing}
            />
          </div>

          <div className='rightSchoolDetails-lower-right'>
            <label> Contact</label>
            <input
              className='contact'
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className='rightSchoolDetails-lower'>
          <div className='rightSchoolDetails-lower-left'>
            <label>Role</label>
            <select
              value={role}
              className='rightSchoolDetails-lower-left-role'
              style={{ height: '32px' }}
              onChange={(e) => setRole(e.target.value)}
              disabled={!isEditing}
            >
              <option value='teacher'>Teacher</option>
              <option value='hod'>Hod</option>
              <option value='principal'>Principal</option>
              <option value='school admin'>School Admin</option>
            </select>
          </div>
          <div className='rightSchoolDetails-lower-right'>
            <label>Expiry Date</label>
            <input
              type='date'
              className='contact expiryDate'
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>

        {/* Password */}
        <div className="rightSchoolDetails-lower" style={{ marginTop: "30px" }}>
          <div className="rightSchoolDetails-lower-left">
            <label>Password</label>
            <input
              type={isEditing ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>

      </div>
      {/* Buttons */}
      <div className='edit_save_button'>
        {!isEditing ? <div className='edit_button'>
          <button onClick={handleEdit}>Edit</button>
        </div>:
        <div className='save_button' onClick={saveDetails}>
          <button>Save</button>
        </div>}
      </div>
    </div>
  );
}

export default TeacherInfo;
